import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallHeaderImage } from '../../../state/prizeWall/prizeWall.slice';
import { PrizeWallWinnersHeaderProps } from './PrizeWallWinnersHeader.types';
import PrizeWallHeaderBase from '../../common/PrizeWallHeaderBase/PrizeWallHeaderBase';
import PrizeWallTokensInfo from '../../PrizeWallTokensInfo/PrizeWallTokensInfo';
import PrizeWallImage from '../../common/PrizeWallImage/PrizeWallImage';
import PrizeWallHeaderImageSkeleton from '../../PrizeWallHeader/PrizeWallHeaderImageSkeleton/PrizeWallHeaderImageSkeleton';

function PrizeWallWinnersHeader(props: PrizeWallWinnersHeaderProps) {
  const headerImage = useSelector(selectPrizeWallHeaderImage);

  return (
    <PrizeWallHeaderBase {...props}>
      {headerImage ? (
        <PrizeWallImage
          {...headerImage}
          marginHorizontal="auto"
          maxWidth={160}
          aspectRatio={4}
        />
      ) : (
        <PrizeWallHeaderImageSkeleton />
      )}
      <PrizeWallTokensInfo />
    </PrizeWallHeaderBase>
  );
}

export default memo(PrizeWallWinnersHeader);
